module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sendSuccess),
      expression: "!sendSuccess"
    }],
    staticClass: "text-color white text-center verify-container"
  }, [_c('div', {
    staticClass: "navbar-panel"
  }, [_vm._v("\n        安全验证\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-30 middle-text"
  }, [_vm._v("\n        验证短信已发送至\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-20 telephone"
  }, [_vm._v("\n        " + _vm._s(_vm._f("secretPhoneNum")(_vm.formItem.telephoneNum)) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "codeInput"
  }, _vm._l((_vm.showVerifyCodes), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "code"
    }, [_vm._v("\n          " + _vm._s(item) + "\n        ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "mt-30 info"
  }, [(this.formItem.codeWorking) ? _c('div', [_vm._v("\n          " + _vm._s(_vm.formItem.timeSecond) + "后可重新发送\n        ")]) : _c('div', [_vm._v("\n          未收到验证短信？ "), _c('a', {
    staticClass: "text-color white resend-code",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.resendCode()
      }
    }
  }, [_vm._v("重新发送")])])])])]), _vm._v(" "), _c('c-keyboard', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sendSuccess),
      expression: "!sendSuccess"
    }],
    on: {
      "key-press": _vm.pushCode,
      "key-del": _vm.deleteCode
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40883e42","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/alpha-sign-up-verify/index.vue
// module id = 362
// module chunks = 0